const footer_pt={
	    "rights":"LEVTY. Todos os Direitos Reservados.",
        "visit":[
            {
                "title":"Acesse",
                "plans":"Planos",
                "career":"Carreiras"
            },
            {
                "title":"Redes sociais",
                "description":"Siga a LEVTY nas redes sociais"
            }
        ],
        "privacyPolicy":"Política de privacidade"
}  
export default footer_pt